<template>
  <v-dialog
    v-model="isActive"
    :max-width="maxWidth"
    heigth="100vh"
    persistent
  >
    <form @submit.prevent.stop="onSubmit">
      <v-card>
        <v-progress-linear
          v-if="isLoading"
          color="info"
          indeterminate
          absolute
        />

        <v-toolbar dense class="elevation-0">
          <slot name="header" />

          <v-spacer />

          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-title class="headline pt-0 BModalConfirm__title">
          <slot name="title-text">
            <span v-html="titleText" />
          </slot>
        </v-card-title>

        <v-card-text>
          <template v-if="isSuccess">
            <span v-html="successText" />
          </template>

          <slot v-else>
            {{ mainText }}
          </slot>

          <template v-if="isError">
            <slot name="error" :messages="errorMessages">
              <div
                v-if="errorMessages"
                class="error--text"
                v-text="errorMessages"
              />
              <div
                v-else
                class="error--text"
                v-html="errorText"
              />
            </slot>
          </template>
        </v-card-text>

        <v-card-actions v-if="isSuccess">
          <slot name="footer" :loading="isLoading" :close="close">
            <v-spacer />

            <v-btn
              depressed
              type="button"
              @click="close()"
              v-text="closeBtn"
            />
          </slot>
        </v-card-actions>

        <v-card-actions v-else class="BModalConfirm__actions">
          <slot name="footer" :loading="isLoading" :close="close">
            <slot
              name="footer-before"
              :loading="isLoading"
              :close="close"
            />

            <v-spacer />

            <v-btn
              v-if="!canceless"
              text
              type="button"
              @click="close()"
              v-text="cancelBtn"
            />

            <v-btn
              v-if="!successless"
              depressed
              :disabled="isLoading"
              type="button"
              @click="$emit('click-success')"
              v-text="successBtn"
            />

            <slot
              name="footer-after"
              :loading="isLoading"
              :close="close"
            />
          </slot>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
import BModalConfirm from '@/components/modals/BModalConfirm.vue'

export default {
  name: 'BModalConfirmTemplate',
  extends: BModalConfirm,
}
</script>
